import React from "react";
import DashboardComponent from "../component/Dashboard/DashboardComponent";
import { Header } from "antd/es/layout/layout";

const DashboardPage = () => {
  return (
    <div>
      <Header
        style={{
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        <b style={{ color: "white", fontSize: "20px" }}>Dashboard</b>
      </Header>
      <DashboardComponent />
    </div>
  );
};

export default DashboardPage;
